import { atom } from "recoil";

export const freelanceBooking= atom({
    key: 'isReserved',
    default: false
});

export const global_domain_id= atom({
    key: 'isDefined',
    default: false
});